module.exports = __webpack_public_path__ + "static/media/gm.f9e84770.svg";